import axios from "axios";
import { toast } from "react-toastify";

// export const BASE_URL = "http://localhost:8000/api";
// export const BASE_URL = "http://192.168.1.6:8080/api/";
export const BASE_URL = "https://api.motogates.com/api";

const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": "ar",
  },
});

API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          localStorage.removeItem("token");
          toast.error("انتهت الجلسة");
          window.location.href = "/login";
          break;
        case 403:
          toast.error(`${error.response.data?.message || "خطأ غير معروف"}`);
          break;
        case 404:
          toast.error(`${error.response.data?.message || "خطأ غير معروف"}`);
          break;
        case 500:
          toast.error("حدث خطأ بالخادم");
          break;
        default:
          toast.error(`${error.response.data?.message || "خطأ غير معروف"}`);
      }
    } else if (error.request) {
      toast.error("تم فقد الاتصال بالخادم");
    } else {
      toast.error(error.message);
    }

    return Promise.reject(error);
  }
);

export default API;
